<div>
    <div class="row">
        <div class="column">
            <mm-from-account-details-condensed [subtitle]="subtitle"></mm-from-account-details-condensed>
        </div>
        <div class="column">
            <mm-recipient-details-wires-condensed></mm-recipient-details-wires-condensed>
        </div>
    </div>
    <mm-transaction-details-wire-condensed [isIra]="isIra"></mm-transaction-details-wire-condensed>
    <mm-twe-details-section *ngIf="isIra" [transactionType]="'wire'" data-testid="twe-details-section_wire"></mm-twe-details-section>
    <mm-ptrs-details-condensed></mm-ptrs-details-condensed>
</div>